import React, { useState, useRef } from "react";
import T from "prop-types";
import { Overlay, Tooltip } from "react-bootstrap";
import { properCase } from "LIB/formatters/text";
import { percent } from "LIB/formatters/number";

export default function CancellationStatsTooltip({ stats }) {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);

  const handleMouseEnter = () => {
    setOpen(true);
  };
  const handleMouseLeave = () => {
    setOpen(false);
  };

  if (!stats) return null;
  if (!stats.cancellations) return null;
  if (Number(stats.purchase_items_cancelled_6_months_count) === 0) return null;

  const cancellationData =
    stats &&
    stats.cancellations.map(c => [
      c.cancellation_reason === "cancelled_by_tenant"
        ? "Cancelled By Us"
        : properCase(c.cancellation_reason),
      percent(
        Number(c.count) / Number(stats.purchase_items_cancelled_6_months_count),
        1
      )
    ]);

  return (
    <React.Fragment>
      <i
        className="fa fa-info-circle"
        style={{
          cursor: "pointer",
          color: "rgba(255, 255, 255, 0.25)",
          fontSize: 12
        }}
        ref={buttonRef}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
      <Overlay target={buttonRef.current} show={open} placement="right">
        <Tooltip id="stat-tooltip" style={{ cursor: "pointer" }}>
          {cancellationData &&
            cancellationData.map(c => (
              <span>
                {c[0]}: <strong>{c[1]}</strong>
                <br />
              </span>
            ))}
        </Tooltip>
      </Overlay>
    </React.Fragment>
  );
}

CancellationStatsTooltip.propTypes = {
  stats: T.shape({})
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/CompanyStats/CancellationStatsTooltip.jsx